// Determines whether a market event should still be shown publicly.
//
// One-time markets (repeatType unset/'none') are upcoming while their date
// hasn't passed. Recurring markets (weekly/monthly/etc.) stay upcoming
// indefinitely unless a repeatEndDate is set and has passed - the `date`
// field on a recurring market is just its original/reference occurrence,
// not a rolling "next occurrence" date, so it can't be used to decide
// expiry for those.
export function isMarketUpcoming(market, referenceDate = new Date()) {
  const today = new Date(referenceDate);
  today.setHours(0, 0, 0, 0);

  const isRecurring = Boolean(market.repeatType) && market.repeatType !== 'none';

  if (isRecurring) {
    if (!market.repeatEndDate) return true;
    const end = new Date(`${market.repeatEndDate}T00:00:00`);
    return end >= today;
  }

  if (!market.date) return true;
  const eventDate = new Date(`${market.date}T00:00:00`);
  return eventDate >= today;
}
